/// <amd-module name="Build/DesignerExtensions/YamlSnippetForm/Components/AzureContainerRegistryPicker" />

import * as React from "react";
import { VssComponent, IVssComponentContext, css } from "VSS/Platform/Layout";
import { ServiceEndpointDetails } from "Build/DesignerExtensions/YamlAssistantLibrary/Contracts/Types";
import { SnippetFormSource } from "Build/DesignerExtensions/YamlSnippetForm/Sources/SnippetFormSource";
import { YamlSnippetInput } from "Pipelines/Common/Library/Contracts/DataProvider";
import { DataSourcePickList } from "Build/DesignerExtensions/YamlSnippetForm/Components/DataSourcePickList";
import { EndpointHelper, Subscription, EndpointConstants } from "Build/DesignerExtensions/YamlSnippetForm/Utilities/EndpointHelper";

interface Props {
    subscription?: Subscription;
    endpointToken?: string;
    className?: string;
    onAllValuesReceived: (info: ServiceEndpointDetails) => void;
    onError(location: string, error: Error): void;
}

interface State {
    registryUrl: string;
}

export class AzureContainerRegistryPicker extends VssComponent<Props, State, IVssComponentContext> {
    private _source: SnippetFormSource;

    constructor(props: Props, context: IVssComponentContext) {
        super(props, context);
        const state: State = {
            registryUrl: "",
        }
        this.state = state;
        this._source = new SnippetFormSource(this.context.pageContext);
    }

    public render(): JSX.Element {
        let containerRegistryInputDefinition = {
            dataSourceBinding: {
                dataSourceName: "AzureRMContainerRegistries",
                resultTemplate: `{ "Value": "{'id':'{{id}}', 'name':'{{name}}' , 'loginServer': '{{ properties.loginServer}}'}", "DisplayValue" : "{{name}}" }`,
                parameters: {}
            },
            dataSourceDependency: "subscriptionId",
            label: "Container registry",
            name: "containerRegistry"
        } as YamlSnippetInput;

        const { className } = this.props;
        return <div className={css("section", className)}>
            <DataSourcePickList
                inputDefinition={containerRegistryInputDefinition}
                serviceConnectionProvider={this._source}
                onValueChanged={this._createServiceEndpointObject}
                getValue={this.getValue}
                onError={this.props.onError}
                preloadItems={true}
                serviceEndpointDetails={EndpointHelper.getAzureRMServiceEndpointDetails(this.context.pageContext, this.props.subscription, this.props.endpointToken)} />
        </div>
    }

    public componentDidMount() {
        super.componentDidMount();
    }

    private getValue = (name: string) => {
        if (name === "subscriptionId") {
            return !!this.props.subscription && this.props.subscription.id ? "0" : "";
        }
        return "";
    }

    private _createServiceEndpointObject = (key: string , registryInfo: string) => {
        let acrRegistry = JSON.parse(registryInfo.replace(/'/g, '"'));
        let registryName = this.getRegistryNameFromRegistryId(acrRegistry.id);
        let endpoint = {
            "data": {
                "registrytype": "ACR",
                "registryId": acrRegistry.id,
                "subscriptionId": this.props.subscription? this.props.subscription.id : "",
                "subscriptionName": this.props.subscription? this.props.subscription.displayName: ""
            },
            "name": registryName,
            "type": EndpointConstants.EndpointTypes.docker,
            "url": `https://${ acrRegistry.loginServer }`,
            "authorization": {
                "scheme": EndpointConstants.AuthSchemes.servicePrincipal,
                "parameters": {
                    "tenantId": this.props.subscription? this.props.subscription.subscriptionAccount.subscriptionTenantId : "",
                    "servicePrincipalId":"<placeholder>",
                    "scope": acrRegistry.id,
                    "loginServer": acrRegistry.loginServer
                }
            } 
        } as ServiceEndpointDetails;

        this.props.onAllValuesReceived(endpoint);

    }

    private getRegistryNameFromRegistryId(registryId: string): string {
        let registryName = "";
        if (registryId) {
            let parts = registryId.split('/');
            let registryNameIndex = parts.findIndex(part => part === "registries") + 1;
            if (registryNameIndex > 0) {
                registryName = parts[registryNameIndex];
            }
        }

        return registryName;
    }
}
